import styled from 'styled-components';
import media from '../../../styles/config/mediaQueries';

export const StyledWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  ${media.mobile`
    max-width: 873px;
    padding: 0 26px;
  `}
`;
